export function isNullOrUndefined(value) {
  return value === null || value === undefined || value.length === 0;
}

export const m_id = "HDFC000000000931";
